import { inject } from "mobx-react";
import React from "react";
import { CreateView, IndexView, ShowView } from "lego-gui-lib";
import {
  EditIvrMenuUserInputSchema,
  IvrMenuUserInputListSchema
} from "./schema";
import { BreadcrumbsItem } from "react-breadcrumbs-dynamic";
import { isAllowed } from "../../../common/common";
import { customRowButtonsForNestedIndex } from "../../../common/CustomerAwareRowButtons";
import { observer } from "mobx-react-lite";
import { useHistory, useRouteMatch } from "react-router";
import { useTranslation } from "react-i18next";

const injectDataSource = (comp: any) =>
  inject("ivrMenuUserInput", "ivrMenu", "i18n")(observer(comp));

export const IvrMenuUserInputCreate = injectDataSource(
  ({ ivrMenuUserInput, ivrMenu, ...rest }: any) => {
    const { t } = useTranslation();
    const match = useRouteMatch();
    const title = t("common:create", {
      domain: "hns:ivrMenuUserInput:domain"
    });

    const baseUrl = match.url;
    const parentTitle = t("common:edit", { domain: "hns:ivrMenu:domain" });
    const parentUrl = baseUrl.substring(0, baseUrl.lastIndexOf("/"));
    const id = {
      // @ts-ignore
      id: match.params.userInputId
    };
    const history = useHistory();

    return (
      <>
        <BreadcrumbsItem to={parentUrl}>{parentTitle}</BreadcrumbsItem>
        <BreadcrumbsItem to={baseUrl}>{title}</BreadcrumbsItem>
        <CreateView
          dataSource={ivrMenuUserInput.oneDataSource}
          title={title}
          {...rest}
          goBack={() => history.goBack()}
          fields={EditIvrMenuUserInputSchema}
          id={id}
        />
      </>
    );
  }
);

export const IvrMenuUserInputEdit = injectDataSource(
  ({ ivrMenuUserInput, ivrMenu, match, i18n, ...rest }: any) => {
    const allowed = isAllowed(ivrMenu);
    const title = allowed
      ? i18n.t("common:edit", {
          domain: "hns:ivrMenuUserInput:domain"
        })
      : i18n.t("hns:ivrMenuUserInput:domain");
    const baseUrl = match.url;
    const parentTitle = i18n.t("common:edit", { domain: "hns:ivrMenu:domain" });
    const parentUrl = baseUrl.substring(0, baseUrl.lastIndexOf("/"));
    const history = useHistory();
    return (
      <>
        <BreadcrumbsItem to={parentUrl}>{parentTitle}</BreadcrumbsItem>
        <BreadcrumbsItem to={baseUrl}>{title}</BreadcrumbsItem>
        <ShowView
          id={{ id: match.params.userInputId }}
          dataSource={ivrMenuUserInput.oneDataSource}
          title={title}
          {...rest}
          fields={EditIvrMenuUserInputSchema}
          goBack={() => history.goBack()}
        />
      </>
    );
  }
);

const toolbarButtons = (isAllowed: boolean) => {
  return isAllowed
    ? { delete: true, export: true }
    : { delete: false, export: true };
};

const titleButtons = (isAllowed: boolean) => (props: any) => {
  if (isAllowed) {
    return undefined;
  } else {
    return <></>;
  }
};

export const IvrMenuUserInputIndex = injectDataSource((props: any) => {
  const { ivrMenuUserInput, ivrMenu, i18n, ...rest } = props;
  const title = i18n.t("hns:ivrMenuUserInput:domain_plural");

  return (
    <IndexView
      dataSource={ivrMenuUserInput.listDataSource}
      {...rest}
      titleButtons={titleButtons(props.isAllowed)}
      toolbarButtons={toolbarButtons(props.isAllowed)}
      rowButtons={(indexProps: any) =>
        customRowButtonsForNestedIndex(indexProps, props.isAllowed)
      }
      title={title}
      baseUrl="/userInputs"
      columns={IvrMenuUserInputListSchema}
    />
  );
});
